"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pinoApplicationInsightsLogHandler = void 0;
var _applicationinsightsWeb = require("@microsoft/applicationinsights-web");
var _pinoStdSerializers = _interopRequireDefault(require("pino-std-serializers"));
var _applicationInsights = require("../../application-insights");
var _definePinoLogHandlers = require("./definePinoLogHandlers");
/* eslint-disable @typescript-eslint/naming-convention -- thats how AI defines it */

/**
 * This is error that acts as a "copy" of the original error as it overrides
 * its own properties with the original values
 */
class DeserializedError extends Error {
  constructor(name, message, stack) {
    super(message);
    // eslint-disable-next-line unicorn/custom-error-definition -- we want everything from the original error, including name
    this.name = name;
    this.stack = stack;
  }
}
const getServerApplicationInsightsTagOverrides = operation => operation ? {
  'ai.operation.id': operation.id,
  'ai.operation.name': operation.name,
  'ai.operation.parentId': operation.parentId
} : undefined;
const pinoApplicationInsightsLogHandler = exports.pinoApplicationInsightsLogHandler = (0, _definePinoLogHandlers.definePinoLogHandlers)({
  onError(message) {
    const {
      enableDebugLogging,
      error: serializedOrNormalError,
      time,
      msg,
      applicationInsightsOperation,
      ...otherMessageProperties
    } = message;
    const ai = _applicationInsights.ApplicationInsights.get();
    // First we need to make sure that every error is first serialized into object
    // In environment with workers this is usually done through pino, but in browser the error is as is
    const {
      type: errorName,
      message: errorMessage,
      stack: errorStack,
      cause: errorCause,
      ...otherProperties
    } = serializedOrNormalError instanceof Error ? _pinoStdSerializers.default.errWithCause(serializedOrNormalError) : serializedOrNormalError;
    const properties = otherMessageProperties;
    if (Object.keys(otherProperties).length > 0) {
      // Attach otherProperties (anything than normal Error.prototype fields) as customDimensions
      // as those would be destroyed in application insights library
      properties.errorProperties = otherProperties;
    }

    // If error has cause we need to prepare it also. We cannot reasonably do this anything than
    // setting that cause as customDimensions data, because Application Insights do not support that
    if (errorCause) {
      const {
        type: causeName,
        message: causeMessage,
        stack: causeStack,
        ...otherCauseProperties
      } = errorCause;
      properties.cause = {
        name: causeName,
        message: causeMessage,
        // This could be enhanced with further parsing
        // just do it like in application insights library https://github.com/microsoft/ApplicationInsights-node.js/blob/b5b173648f095c8cea7dcf414521ab5b9fe12ab6/src/logs/exceptions.ts#L127
        stack: causeStack,
        ...(Object.keys(otherCauseProperties).length > 0 ? {
          errorProperties: otherCauseProperties
        } : null)
      };
    }

    // Lastly we create a "copy" of the original error for application insights
    const exception = new DeserializedError(errorName, errorMessage, errorStack);
    if ((0, _applicationInsights.isServerApplicationInsightsClient)(ai)) {
      ai.defaultClient.trackException({
        exception,
        time: new Date(time),
        severity: ai.Contracts.SeverityLevel.Error,
        properties,
        tagOverrides: getServerApplicationInsightsTagOverrides(applicationInsightsOperation)
      });
    } else {
      ai.trackException({
        exception,
        properties
      });
    }
  },
  // Lets leave this on here for the future
  onInfo(message) {
    const {
      msg = '',
      time,
      applicationInsightsOperation,
      enableDebugLogging,
      ...otherProperties
    } = message;
    const ai = _applicationInsights.ApplicationInsights.get();
    if ((0, _applicationInsights.isServerApplicationInsightsClient)(ai)) {
      ai.defaultClient.trackTrace({
        message: msg,
        time: new Date(time),
        severity: ai.Contracts.SeverityLevel.Information,
        properties: otherProperties,
        tagOverrides: getServerApplicationInsightsTagOverrides(applicationInsightsOperation)
      });
    } else {
      ai.trackTrace({
        message: msg,
        severityLevel: _applicationinsightsWeb.SeverityLevel.Information,
        properties: otherProperties
      });
    }
  },
  onMetric(message) {
    const {
      metricName,
      metricValue,
      time,
      applicationInsightsOperation,
      enableDebugLogging,
      // no need to send to ai
      ...otherMesageProperties
    } = message;
    const ai = _applicationInsights.ApplicationInsights.get();
    if ((0, _applicationInsights.isServerApplicationInsightsClient)(ai)) {
      ai.defaultClient.trackMetric({
        name: metricName,
        value: metricValue,
        time: new Date(time),
        properties: otherMesageProperties,
        tagOverrides: getServerApplicationInsightsTagOverrides(applicationInsightsOperation)
      });
    } else {
      ai.trackMetric({
        name: metricName,
        average: metricValue,
        properties: otherMesageProperties
      });
    }
  },
  onWarn(message) {
    const {
      msg = '',
      time,
      applicationInsightsOperation,
      enableDebugLogging,
      ...otherProperties
    } = message;
    const ai = _applicationInsights.ApplicationInsights.get();
    if ((0, _applicationInsights.isServerApplicationInsightsClient)(ai)) {
      ai.defaultClient.trackTrace({
        message: msg,
        time: new Date(time),
        severity: ai.Contracts.SeverityLevel.Warning,
        properties: otherProperties,
        tagOverrides: getServerApplicationInsightsTagOverrides(applicationInsightsOperation)
      });
    } else {
      ai.trackTrace({
        message: msg,
        severityLevel: _applicationinsightsWeb.SeverityLevel.Warning,
        properties: otherProperties
      });
    }
  }
});
//# sourceMappingURL=pinoApplicationInsightsLogHandler.js.map